import styled from 'styled-components';

export const RightSideBarStyled = styled.div`
  width: 100%;
  height: 100vh;
  z-index: 1101;
  position: fixed;
  top: 0;
  left: 0;
  &.epharmacy {
    background-color: ${(props) => props.theme.color.white};
  }
  .text_remain_count {
    color: #78909c;
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: 16px;
    text-align: right;
    padding-top: 8px;
  }
`;
